export namespace PdfTemplateTranslations {
  export const common = {
    pdfTemplate: 'pdfTemplate',
    generatePdf: 'generatePdf',

    noPdfTemplateYetTitle: 'noPdfTemplateYetTitle',
  } as const;

  export const error = {
    pdfTemplatesUnableToLoadError: 'pdfTemplatesUnableToLoadError',
  } as const;

  export const toast = {
    pdfTemplateCreatedSuccessfullyToastTitle: 'pdfTemplateCreatedSuccessfullyToastTitle',
    pdfTemplateUpdatedSuccessfullyToastTitle: 'pdfTemplateUpdatedSuccessfullyToastTitle',
    pdfTemplateDeletedSuccessfullyToastTitle: 'pdfTemplateDeletedSuccessfullyToastTitle',
  } as const;
}
